/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import Autocomplete from "react-google-autocomplete";
import validator from "validator";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import Header from "../../_legacy/Containers/Guest/Header.js";
import Footer from "../../_legacy/Containers/Guest/Footer.js";
import {
  signUp,
  signUpBasic,
  checkUniqueEmail,
  checkEmail,
} from "../../Actions/SignUp/signUpAction.js";
import TextBox from "./TextBox";
import ContactNumber from "./ContactNumber";
import BbaPolicy from "../Policies/BbaPolicy.js";
import TermsOfService from "../Policies/TermsOfService.js";
import Loader from "../Common/Loader.js";
import { COUNTRIES } from "../../consts/general.js";
import { Recaptcha } from "../../shared/Recaptcha/Recaptcha.js";
import { http } from "../../services/HttpService.js";
import { uiNotification } from "../../services/UINotificationService.js";

class SignUpBasic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invite_key: this.props.match.params.invite_key
        ? this.props.match.params.invite_key
        : "",
      firstname: "",
      lastname: "",
      email: "",
      contactNumber: "",
      password: "",
      confirm_password: "",
      business_name: "",
      business_address: "",
      zipcode: "",
      city: "",
      state: "",
      country: "US",
      suite_number: "",
      term_condition: false,
      agree_checkbox: false,
      isHppaPolicyAccepted: false,
      isBbaPolicyAccepted: false,
      firstNameClass: "form-control",
      lastNameClass: "form-control",
      emailClass: "form-control",
      contactNumberClass: "form-control p-l-55",
      passwordClass: "form-control",
      confirmPasswordClass: "form-control",
      businessNameClass: "form-control",
      businessAddressClass: "form-control",
      zipcodeClass: "form-control",
      cityClass: "form-control",
      stateClass: "form-control",
      termconditionClass: "",
      agreecheckboxClass: "",
      defaultCountry: "us",
      contactNumberError: false,
      isRender: false,
      processingLoder: false,
      isShowInfo: true,
      isShowTerms: false,
      isShowBba: false,
      signUpData: {},
      uniqueEmailData: {},
      isUniqueEmail: false,
      isInfoValid: false,
      globalLang: {},
      removePassword: false,
      existsAsTouchMD: false,

      recaptcha: "",
      recaptchaInstance: "",
      recaptchaError: "",
      sitekey: process.env.REACT_APP_CAPTCHA_SITE_KEY,
    };
  }

  componentDidMount() {
    localStorage.removeItem("accountSetupFile");
    localStorage.removeItem("accountSetupStatus");
    this.props.signUp();
    let languageData = {};
    if (localStorage.getItem("languageData")) {
      languageData = JSON.parse(localStorage.getItem("languageData"));
    }
    if (
      !languageData ||
      languageData.global === undefined ||
      !languageData.global
    ) {
      http
        .get("getLanguageText/1/global")
        .then((res) => {
          languageData = res.data.data;
          if (languageData.country_code) {
            localStorage.setItem("cCode", languageData.country_code);
          }
          this.setState({
            globalLang:
              languageData && languageData.global ? languageData.global : null,
            isRender: true,
          });
          localStorage.setItem("languageData", JSON.stringify(languageData));
        })
        .catch(function () {});
    } else {
      this.setState({
        globalLang:
          languageData && languageData.global ? languageData.global : null,
        isRender: true,
      });
    }

    let accountSetupInterval = localStorage.getItem("accountSetupInterval");
    if (accountSetupInterval) {
      clearInterval(accountSetupInterval);
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let returnState = {};
    if (nextProps.showLoader != undefined && nextProps.showLoader == false) {
      return { showLoader: false };
    }
    if (
      nextProps.processingLoder != undefined &&
      nextProps.processingLoder == false
    ) {
      returnState.processingLoder = false;
    } else if (
      nextProps.signUpData != undefined &&
      nextProps.signUpData != prevState.signUpData
    ) {
      returnState.signUpData = nextProps.signUpData;
      return <div>{nextProps.history.push(`/account-setup/basic`)}</div>;
    }
    if (nextProps.isUniqueEmail != undefined) {
      returnState.isUniqueEmail = nextProps.isUniqueEmail;
      returnState.showLoader = false;
      returnState.processingLoder = false;
      if (!nextProps.isUniqueEmail) {
        returnState.removePassword = true;
        returnState.existsAsTouchMD = nextProps.existsAsTouchMD
          ? nextProps.existsAsTouchMD
          : false;
      } else if (
        nextProps.isUniqueEmail == true &&
        nextProps.isUniqueEmail != prevState.isUniqueEmail
      ) {
        returnState.removePassword = false;
        returnState.existsAsTouchMD = false;
        if (prevState.isInfoValid) {
          returnState.isShowInfo = false;
          returnState.isShowBba = true;
          returnState.isShowTerms = false;
        }
      }
    }
    return returnState;
  }

  handleInputChange = (event) => {
    const target = event.target;
    const name = event.target.name;
    let value = target.type === "checkbox" ? target.checked : target.value;
    if (name == "password" || name == "confirm_password" || name == "email") {
      value = value.trim();
    }
    this.setState({
      [name]: value,
    });
  };

  handleChildChange = (value) => {
    this.setState(value);
  };

  handleInfoSubmit = (event) => {
    uiNotification.clear();
    if (typeof event === "object") {
      event.preventDefault();
    }
    this.setState({ isInfoValid: false });
    let error = false;
    let toastError = false;
    let regularExpression =
      /^(?=.{8,})(?=.*[A-Z])(?=.*[`~*-/[\]\\|{}().:;,''""!_<>-@#$%^&+=]).*$/;
    if (
      typeof this.state.firstname == undefined ||
      this.state.firstname == null ||
      this.state.firstname == ""
    ) {
      this.setState({ firstNameClass: "form-control field_error" });
      error = true;
    } else if (this.state.firstname) {
      this.setState({ firstNameClass: "form-control" });
    }

    if (
      typeof this.state.lastname == undefined ||
      this.state.lastname == null ||
      this.state.lastname == ""
    ) {
      this.setState({ lastNameClass: "form-control field_error" });
      error = true;
    } else if (this.state.lastname) {
      this.setState({ lastNameClass: "form-control" });
    }

    if (
      typeof this.state.email == undefined ||
      this.state.email == null ||
      this.state.email == ""
    ) {
      this.setState({ emailClass: "form-control field_error" });
      error = true;
    } else {
      if (!validator.isEmail(this.state.email)) {
        this.setState({ emailClass: "form-control field_error" });
        error = true;
        uiNotification.error(this.state.globalLang.signup_error_email_valid);
        toastError = true;
      } else {
        this.setState({
          emailClass: "form-control",
          isUniqueEmail: false,
          uniqueEmailData: {},
        });
      }
    }

    if (
      typeof this.state.contactNumber == undefined ||
      this.state.contactNumber == null ||
      this.state.contactNumber == ""
    ) {
      this.setState({ contactNumberClass: "form-control p-l-55 field_error" });
      error = true;
    } else {
      if (this.state.contactNumberError) {
        this.setState({
          contactNumberClass: "form-control p-l-55 field_error",
        });
        error = true;
        if (!toastError) {
          uiNotification.error(
            this.state.globalLang.signup_error_phone_number_valid,
          );
        }
        toastError = true;
      } else if (this.state.contactNumber.length <= 9) {
        this.setState({
          contactNumberClass: "form-control p-l-55 field_error",
        });
        error = true;
        if (!toastError) {
          uiNotification.error(
            this.state.globalLang.signup_error_phone_number_valid,
          );
        }
        toastError = true;
      } else {
        this.setState({ contactNumberClass: "form-control p-l-55" });
      }
    }

    if (
      (typeof this.state.password === undefined ||
        this.state.password === null ||
        this.state.password === "" ||
        this.state.password.trim() == "") &&
      this.state.removePassword == false
    ) {
      this.setState({ passwordClass: "form-control field_error" });
      error = true;
    } else if (this.state.password && this.state.removePassword == false) {
      if (this.state.password.length < 8) {
        this.setState({ passwordClass: "form-control field_error" });
        error = true;
        if (!toastError) {
          uiNotification.error(
            this.state.globalLang.signup_error_password_length,
          );
        }
        toastError = true;
      } else if (!regularExpression.test(this.state.password)) {
        this.setState({ passwordClass: "form-control field_error" });
        error = true;
        if (!toastError) {
          uiNotification.error(
            this.state.globalLang.signup_error_password_combination,
          );
        }
        toastError = true;
      } else if (this.state.password !== this.state.confirm_password) {
        this.setState({ passwordClass: "form-control field_error" });
        error = true;
        if (!toastError) {
          uiNotification.error(
            this.state.globalLang.signup_error_password_match_with_confirm,
          );
        }
        toastError = true;
      } else {
        this.setState({ passwordClass: "form-control" });
      }
    }

    if (
      (typeof this.state.confirm_password === undefined ||
        this.state.confirm_password === null ||
        this.state.confirm_password === "") &&
      this.state.removePassword == false
    ) {
      this.setState({ confirmPasswordClass: "form-control field_error" });
      error = true;
      if (this.state.password.length > 0) {
        this.setState({ passwordClass: "form-control field_error" });
        error = true;
        if (!toastError) {
          uiNotification.error(
            this.state.globalLang.signup_error_password_combination,
          );
        }
        toastError = true;
      }
    } else if (
      this.state.confirm_password &&
      this.state.removePassword == false
    ) {
      if (this.state.password !== this.state.confirm_password) {
        this.setState({
          passwordClass: "form-control field_error",
          confirmPasswordClass: "form-control field_error",
        });
        error = true;
        if (!toastError) {
          uiNotification.error(
            this.state.globalLang.signup_error_password_combination,
          );
        }
        toastError = true;
      } else {
        this.setState({ confirmPasswordClass: "form-control" });
      }
    }

    if (
      typeof this.state.business_name === undefined ||
      this.state.business_name === null ||
      this.state.business_name === ""
    ) {
      this.setState({ businessNameClass: "form-control field_error" });
      error = true;
    } else if (this.state.firstname) {
      this.setState({ businessNameClass: "form-control" });
    }

    if (
      typeof this.state.business_address === undefined ||
      this.state.business_address === null ||
      this.state.business_address === ""
    ) {
      this.setState({ businessAddressClass: "form-control field_error" });
      error = true;
    } else if (this.state.firstname) {
      this.setState({ businessAddressClass: "form-control" });
    }

    if (
      typeof this.state.zipcode === undefined ||
      this.state.zipcode === null ||
      this.state.zipcode === ""
    ) {
      this.setState({ zipcodeClass: "form-control field_error" });
      error = true;
    } else if (this.state.firstname) {
      this.setState({ zipcodeClass: "form-control" });
    }

    if (
      typeof this.state.city === undefined ||
      this.state.city === null ||
      this.state.city === ""
    ) {
      this.setState({ cityClass: "form-control field_error" });
      error = true;
    } else if (this.state.firstname) {
      this.setState({ cityClass: "form-control" });
    }

    if (
      typeof this.state.state === undefined ||
      this.state.state === null ||
      this.state.state === ""
    ) {
      this.setState({ stateClass: "form-control field_error" });
      error = true;
    } else if (this.state.firstname) {
      this.setState({ stateClass: "form-control" });
    }

    if (!this.state.term_condition && !toastError) {
      uiNotification.error(
        this.state.globalLang.signup_error_accept_terms_of_services,
      );
      error = true;
      toastError = true;
    }

    if (
      typeof this.state.recaptchaError === undefined ||
      this.state.recaptchaError === null ||
      this.state.recaptchaError.trim() === ""
    ) {
      uiNotification.error("Please verify recaptcha!");
      error = true;
      toastError = true;
    }

    if (!this.state.country) {
      error = true;
      toastError = true;
      uiNotification.error("Please select country");
    }

    if (error) {
      this.toggleSignUpForm("isShowInfo");
      return;
    } else {
      this.setState({ isInfoValid: true });
      this.toggleSignUpForm("isShowTerms");
    }
  };

  toggleSignUpForm = (nextStep, isSubmit) => {
    isSubmit = isSubmit || false;
    this.setState({
      isShowInfo: false,
      isShowBba: false,
      isShowTerms: nextStep == "isShowTerms" || isSubmit == true ? true : false,
      [nextStep]: true,
    });
    if (isSubmit) {
      this.setState({ processingLoder: true });
      let formData = {};
      formData.firstname = this.state.firstname;
      formData.lastname = this.state.lastname;
      formData.email_id = this.state.email;
      formData.contact_number_1 = this.state.contactNumber;
      formData.password =
        this.state.removePassword == false ? this.state.password : "";
      formData.confirm_password =
        this.state.removePassword == false ? this.state.confirm_password : "";
      formData.business_name = this.state.business_name;
      formData.term_condition = this.state.term_condition ? 1 : 0;
      formData.agree_checkbox = this.state.agree_checkbox ? 1 : 0;
      formData.invite_key = this.state.invite_key ? this.state.invite_key : "";
      formData.business_address = this.state.business_address;
      formData.business_city = this.state.city;
      formData.business_state = this.state.state;
      formData.business_zip = this.state.zipcode;
      formData.business_country = this.state.country;
      formData.business_suite_number = this.state.suite_number;

      this.props.signUpBasic(formData);
    }
  };

  selectLocation = (place) => {
    let zipcode = "";
    let city = "";
    let state = "";
    let country = "";
    let address = "";
    let inputName = (document.getElementById("business_address").value = "");

    if (place.address_components && place.name) {
      place.address_components.map((data) => {
        if (
          data.types[0] == "route" ||
          data.types[0] == "street_number" ||
          data.types[0] == "neighborhood"
        ) {
          address = data.long_name ? address + data.long_name + " " : "";
        }

        if (data.types[0] == "locality" || data.types[0] == "postal_town") {
          city = data.long_name ? data.long_name : "";
        }

        if (city == "") {
          if (data.types[0] == "administrative_area_level_2") {
            city = data.long_name ? data.long_name : "";
          }
        }

        if (data.types[0] == "administrative_area_level_1") {
          state = data.short_name ? data.short_name : "";
        }

        if (data.types[0] == "country") {
          country = data.short_name ? data.short_name : "";
        }

        if (data.types[0] == "postal_code") {
          zipcode = data.long_name ? data.long_name : "";
        }

        if (zipcode == "") {
          if (data.types[0] == "postal_code_prefix") {
            zipcode = data.long_name ? data.long_name : "";
          }
        }

        if (address) {
          inputName = address.trim();
        }

        document.getElementById("business_address").value = inputName;
      });

      this.setState({
        city,
        state,
        country,
        business_address: address.trim(),
        zipcode: zipcode,
      });
    }
  };

  checkEmail = () => {
    if (!validator.isEmail(this.state.email)) {
      this.setState({ emailClass: "form-control field_error" });
      uiNotification.error(this.state.globalLang.signup_error_email_valid);
    } else {
      let formData = {
        email_id: this.state.email,
        type: "signup",
      };
      this.props.checkUniqueEmail(formData);
      this.setState({
        emailClass: "form-control",
        isUniqueEmail: false,
        uniqueEmailData: {},
        showLoader: true,
      });
    }
  };

  asyncScriptOnLoad = () => {
    this.setState({ callback: "called!" });
  };

  handleChange = (response) => {
    this.setState({ recaptchaError: response });
  };

  errorCallback = () => {};

  expiredCallback = () => {
    uiNotification.error("Recaptcha has expired. Please verify it again!");
    this.setState({
      recaptchaError: "Recaptcha has expired. Please verify it again!",
    });
  };

  resetRecaptcha = () => {
    const recaptchaInstance = this.state.recaptchaInstance;
    recaptchaInstance.reset();
  };

  render() {
    return (
      <div className="guest">
        <Header />
        <div className="wrapper">
          {/*  Info Data Block START  */}
          <div
            className={this.state.isShowInfo ? "info-block" : "info-block hide"}
          >
            <div className="login-main sign-up-main">
              <form onSubmit={this.handleInfoSubmit}>
                <h1 className="login-title">
                  {this.state.globalLang.signup_basic_for_your_14_day_trial}
                </h1>
                <div className="form-group row">
                  <div className="col-sm-6 first-name">
                    <TextBox
                      name="firstname"
                      value={this.state.firstname}
                      handleInputChange={this.handleInputChange}
                      class={this.state.firstNameClass}
                      placeholder={
                        this.state.globalLang.signup_placeholder_first_name
                      }
                      type="text"
                      label={this.state.globalLang.signup_label_your_name}
                      isRequired={true}
                    />
                  </div>
                  <div className="col-sm-6 last-name">
                    <TextBox
                      name="lastname"
                      value={this.state.lastname}
                      handleInputChange={this.handleInputChange}
                      class={this.state.lastNameClass}
                      placeholder={
                        this.state.globalLang.signup_placeholder_last_name
                      }
                      type="text"
                      label="&nbsp;"
                      isRequired={false}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-sm-12">
                    <div className="field-group">
                      <label htmlFor="usr">
                        Email<span className="required">*</span>
                      </label>
                      <input
                        name="email"
                        onBlur={this.checkEmail}
                        value={this.state.email}
                        onChange={this.handleInputChange}
                        className={this.state.emailClass}
                        placeholder={
                          this.state.globalLang.signup_placeholder_email
                        }
                        type="text"
                        autoComplete="new-password"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-sm-12">
                    <ContactNumber
                      name="contactNumber"
                      value={this.state.contactNumber}
                      handleChildChange={this.handleChildChange}
                      class={this.state.contactNumberClass}
                      placeholder={
                        this.state.globalLang.signup_placeholder_phone
                      }
                      type="text"
                      label={this.state.globalLang.signup_label_phone}
                      isRequired={true}
                      isRender={this.state.isRender}
                    />
                  </div>
                </div>
                {this.state.removePassword == false && (
                  <div className="form-group row">
                    <div className="col-sm-6 first-name">
                      <TextBox
                        name="password"
                        value={this.state.password}
                        handleInputChange={this.handleInputChange}
                        class={this.state.passwordClass}
                        placeholder={
                          this.state.globalLang.signup_placeholder_password
                        }
                        type="password"
                        label={this.state.globalLang.signup_label_password}
                        isRequired={true}
                      />
                    </div>
                    <div className="col-sm-6 last-name">
                      <TextBox
                        name="confirm_password"
                        value={this.state.confirm_password}
                        handleInputChange={this.handleInputChange}
                        class={this.state.confirmPasswordClass}
                        placeholder={
                          this.state.globalLang
                            .signup_placeholder_retype_password
                        }
                        type="password"
                        label="&nbsp;"
                        isRequired={false}
                      />
                    </div>
                  </div>
                )}
                <div className="form-group row">
                  <div className="col-sm-12">
                    <TextBox
                      name="business_name"
                      value={this.state.business_name}
                      handleInputChange={this.handleInputChange}
                      class={this.state.businessNameClass}
                      placeholder={
                        this.state.globalLang.signup_placeholder_business_name
                      }
                      type="text"
                      label={this.state.globalLang.signup_label_business_name}
                      isRequired={true}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-6">
                    <div className="field-group">
                      <label htmlFor="usr">
                        Business Address
                        <span className="required">*</span>
                      </label>
                      <Autocomplete
                        id="business_address"
                        placeholder="Business Address"
                        className={this.state.businessAddressClass}
                        onPlaceSelected={(place) => this.selectLocation(place)}
                        types={[]}
                        fields={[
                          "address_component",
                          "formatted_address",
                          "geometry",
                          "name",
                          "place_id",
                          "plus_code",
                          "type",
                          "formatted_phone_number",
                          "international_phone_number",
                          "opening_hours",
                          "website",
                        ]}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <TextBox
                      name="zipcode"
                      value={this.state.zipcode}
                      handleInputChange={this.handleInputChange}
                      class={this.state.zipcodeClass}
                      placeholder={
                        this.state.globalLang.signup_placeholder_zip_code
                      }
                      type="text"
                      label={this.state.globalLang.signup_label_zip_code}
                      isRequired={true}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-6">
                    <TextBox
                      name="city"
                      value={this.state.city}
                      handleInputChange={this.handleInputChange}
                      class={this.state.cityClass}
                      placeholder={
                        this.state.globalLang.signup_placeholder_city
                      }
                      type="text"
                      label={this.state.globalLang.signup_label_city}
                      isRequired={true}
                    />
                  </div>
                  <div className="col-sm-6">
                    <TextBox
                      name="state"
                      value={this.state.state}
                      handleInputChange={this.handleInputChange}
                      class={this.state.stateClass}
                      placeholder={
                        this.state.globalLang.signup_placeholder_state
                      }
                      type="text"
                      label={this.state.globalLang.signup_label_state}
                      isRequired={true}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-6">
                    <div className="field-group">
                      <label htmlFor="usr">
                        Country
                        <span className="required">*</span>
                      </label>
                      <select
                        name="country"
                        value={this.state.country}
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ country: e.target.value });
                        }}
                      >
                        <option value="" disabled>
                          Select Country
                        </option>
                        {COUNTRIES.map((obj, idx) => (
                          <option
                            key={idx}
                            value={obj.code}
                            selected={obj.code === this.state.country}
                          >
                            {obj.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <TextBox
                      name="suite_number"
                      value={this.state.suite_number}
                      handleInputChange={this.handleInputChange}
                      placeholder="Suite Number"
                      type="text"
                      label="Suite Number"
                      class="form-control"
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-12 terms text-left">
                    <input
                      type="checkbox"
                      className={this.state.termConditionClass}
                      name="term_condition"
                      checked={this.state.term_condition ? "checked" : false}
                      onChange={this.handleInputChange}
                    />{" "}
                    {this.state.globalLang.signup_i_agree_to_the}{" "}
                    <a
                      href="https://www.aestheticrecord.com/terms-of-service"
                      target="_blank"
                    >
                      {
                        this.state.globalLang
                          .signup_aesthetic_record_terms_of_service_link
                      }
                    </a>
                  </div>
                  {this.state.removePassword == true &&
                    !this.state.existsAsTouchMD && (
                      <div className="col-sm-12 terms colorAR text-left m-t-20">
                        You already have account in our system. You can login
                        with same password to access this new account.
                      </div>
                    )}
                  {this.state.removePassword == true &&
                    this.state.existsAsTouchMD && (
                      <div className="col-sm-12 terms colorRed text-left m-t-20">
                        You already have an account on AR.
                      </div>
                    )}
                </div>
                <div className={""}>
                  <Recaptcha
                    style={{ display: "inline-block" }}
                    onChange={this.handleChange}
                    onExpired={this.expiredCallback}
                    onError={this.errorCallback}
                    asyncScriptOnLoad={this.asyncScriptOnLoad}
                  />
                </div>
                <div className="form-group">
                  <button
                    type="submit"
                    disabled={
                      this.state.removePassword == true &&
                      this.state.existsAsTouchMD
                        ? true
                        : false
                    }
                    className={
                      this.state.removePassword == true &&
                      this.state.existsAsTouchMD
                        ? "subscriptionBtn disable"
                        : "subscriptionBtn"
                    }
                  >
                    {this.state.globalLang.signup_button_continue}
                  </button>
                </div>
              </form>
            </div>
          </div>
          {/*  Info Data Block END  */}
          {/*  Hippa Policy Block START  */}
          <div className="sign-up-main">
            <div
              className={
                this.state.isShowTerms ? "hippa-block" : "hippa-block hide"
              }
            >
              <TermsOfService
                handleChildChange={this.handleChildChange}
                toggleSignUpForm={this.toggleSignUpForm}
                handleInputChange={this.handleInputChange}
                name="agree_checkbox"
                value={this.state.agree_checkbox}
                nextStep={"isShowTerms"}
                processingLoader={this.state.processingLoder}
                globalLang={this.state.globalLang}
                signUpLabel={
                  this.state.globalLang.signup_basic_for_your_14_day_trial
                }
              />
            </div>
          </div>
          {/*  Hippa Policy Block END  */}
          {/*  Bba Policy Block START  */}
          <div className="sign-up-main">
            <div
              className={this.state.isShowBba ? "bba-block" : "bba-block hide"}
            >
              <BbaPolicy
                handleChildChange={this.handleChildChange}
                toggleSignUpForm={this.toggleSignUpForm}
                nextStep={"isShowTerms"}
                globalLang={this.state.globalLang}
                signUpLabel={
                  this.state.globalLang.signup_basic_for_your_14_day_trial
                }
              />
            </div>
          </div>
          {/*  Bba Policy Block END  */}
        </div>

        <div className="sign-up-main">
          <center>
            <img
              alt=""
              className="banner-image"
              src="/images/signup-banner1.png"
            />
          </center>
        </div>
        <Loader showLoader={this.state.showLoader} isFullWidth={true} />
        <Footer globalLang={this.state.globalLang} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const returnState = {};
  if (state.SignUpReducer.action === "SIGN_UP_BASIC") {
    if (state.SignUpReducer.data.status != 201) {
      uiNotification.clear();
      const languageData = JSON.parse(localStorage.getItem("languageData"));
      uiNotification.error(
        languageData.global[state.SignUpReducer.data.message],
      );
      returnState.processingLoder = true;
      returnState.showLoader = false;
    } else {
      localStorage.setItem("accountSetupFile", state.SignUpReducer.data.data);
      localStorage.setItem("accountSetupStatus", 0);
      returnState.signUpData = state.SignUpReducer.data.data;
    }
  } else if (state.SignUpReducer.action === "UNIQUE_EMAIL") {
    if (state.SignUpReducer.data.status != 200) {
      uiNotification.clear();
      if (
        state.SignUpReducer.data.data &&
        state.SignUpReducer.data.data.status &&
        state.SignUpReducer.data.data.status == "exists_as_touchmd"
      ) {
        returnState.existsAsTouchMD = true;
      }
      returnState.isUniqueEmail = false;
    } else {
      returnState.isUniqueEmail = true;
    }
  }

  return returnState;
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      signUp,
      signUpBasic,
      checkUniqueEmail,
      checkEmail,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SignUpBasic));
